import React, { useState, useEffect } from 'react';
import styles from './FilterLot.module.scss';
import { FormControl, MenuItem, Select, InputLabel } from '@material-ui/core';
import CustomButton from '../../../../layout/customButton/CustomButton';
import { connect } from 'react-redux';

const FilterLot = (props) => {
	const {
		filteredAvailability,
		filteredSalesAgent,
		filteredSize,
		setFilteredAvailability,
		setFilteredSalesAgent,
		setFilteredSize,
		closeModalHandler,
		salesAgents,
	} = props;
	const [availability, setAvailability] = useState('');
	const [salesAgent, setSalesAgent] = useState('');
	const [size, setSize] = useState('');

	useEffect(() => {
		setAvailability(filteredAvailability);
	}, [filteredAvailability]);

	useEffect(() => {
		setSize(filteredSize);
	}, [filteredSize]);

	useEffect(() => {
		setSalesAgent(filteredSalesAgent);
	}, [filteredSalesAgent]);

	const handleChange = (e) => {
		if (e.target.name === 'availability') {
			setAvailability(e.target.value);
		} else if (e.target.name === 'salesAgent') {
			setSalesAgent(e.target.value);
		} else if (e.target.name === 'size') {
			setSize(e.target.value);
		}
	};

	const handleApply = () => {
		setFilteredAvailability(availability);
		setFilteredSalesAgent(salesAgent);
		setFilteredSize(size);
		closeModalHandler();
	};

	return (
		<div className={styles.filter_lot}>
			<FormControl variant='outlined' className={styles.select}>
				<InputLabel id='availability-label'>Availability</InputLabel>
				<Select
					labelId='availability-label'
					label='Availability'
					value={availability}
					name='availability'
					onChange={(e) => handleChange(e)}
				>
					<MenuItem value=''>None</MenuItem>
					<MenuItem value='soldout'>Sold Out</MenuItem>
					<MenuItem value='pending'>Pending</MenuItem>
					<MenuItem value='available'>Available</MenuItem>
					<MenuItem value='hold'>Hold</MenuItem>
				</Select>
			</FormControl>
			<FormControl variant='outlined' className={styles.select}>
				<InputLabel id='salesagent-label'>Sales Agent</InputLabel>
				<Select
					labelId='salesagent-label'
					label='Sales Agent'
					value={salesAgent}
					name='salesAgent'
					onChange={(e) => handleChange(e)}
				>
					<MenuItem value=''>None</MenuItem>
					{salesAgents?.map((salesAgent, index) => (
						<MenuItem key={index} value={salesAgent.salesAgentId}>
							{salesAgent.salesAgentName}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<FormControl variant='outlined' className={styles.select}>
				<InputLabel id='size-label'>Size</InputLabel>
				<Select
					labelId='size-label'
					label='Size'
					value={size}
					name='size'
					onChange={(e) => handleChange(e)}
				>
					<MenuItem value=''>None</MenuItem>
					<MenuItem value='50'>50'</MenuItem>
					<MenuItem value='70'>70'</MenuItem>
				</Select>
			</FormControl>
			<div className={styles.apply_btn}>
				<CustomButton width='166' height='42' onClick={handleApply}>
					Apply
				</CustomButton>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	salesAgents: state.siteplanManagement.salesAgents,
});

export default connect(mapStateToProps)(FilterLot);
